import { FC, useMemo } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { ProUpload, ProButton, ProNotification } from '../../antd';
import classNames from 'classnames';
import { getExtraData } from '../utils';
import { getTimeRandom } from '../../utils/dataUtils';
import { AliyunUploadFileProps, EXPIRE_TIME } from '../interface';
import {
  UploadFile,
  UploadChangeParam,
  RcFile,
} from 'antd/lib/upload/interface';

const Plupload: FC<AliyunUploadFileProps> = props => {
  const {
    scene,
    uploadIcon,
    OSSData,
    uploadText,
    disabled,
    listType,
    className,
    size,
    onChange,
    onReset,
    onComplete,
    beforeUpload,
    ...restProps
  } = props;
  /** 上传前数据处理 */
  const handleBeforeUpload = async (file: any, FileList: RcFile[]) => {
    if (beforeUpload) {
      const beforeData = beforeUpload(file, FileList);
      if (beforeData === false || beforeData === ProUpload.LIST_IGNORE)
        return ProUpload.LIST_IGNORE;
    }
    if (!OSSData) return false;
    const { dir, endpoint, expire } = OSSData;
    const nowTime = Date.now() + EXPIRE_TIME;
    const expireTime = Number(expire) * 1000;
    if (expireTime < nowTime) {
      scene && window.sessionStorage.setItem(scene, '');
      await onReset?.();
    }
    const suffix = file.name.slice(file.name.lastIndexOf('.'));
    const randomFlag = getTimeRandom();
    const filename = `${randomFlag}${suffix}`;
    const url: string = dir + filename;
    file.relativePath = `/${url}`;
    file.thumbUrl = `${endpoint}/${dir}${filename}`;
    file.url = `${endpoint}/${url}`;
    return file;
  };
  /** 获取参数 */
  const handleExtraData = (file: UploadFile<any>) => {
    return getExtraData(file, OSSData);
  };
  /** 上传文件改变时 */
  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    const { fileList, file } = info;
    if (file.status === 'error') {
      ProNotification.warning({
        message: `${file.name}上传失败`,
      });
    }
    const newFileList = fileList
      .filter(item => item.status !== 'error')
      .map(item => {
        const { thumbUrl, ...restItem } = item;
        if (item.status !== 'done') {
          return restItem;
        }
        return item;
      });
    if (file.status === 'done') {
      onComplete?.(file);
      onChange?.(newFileList);
      return false;
    }
    onChange?.(
      Array.isArray(newFileList) && newFileList.length
        ? newFileList
        : undefined,
    );
  };
  /** 操作按钮 */
  const uploadButton = () => {
    if (listType === 'picture') {
      return (
        <ProButton icon={uploadIcon} size={size === 'small' ? 'small' : 'middle'}>{uploadText}</ProButton>
      );
    }
    if (listType === 'picture-card') {
      return (
        <div>
          {uploadIcon}
          <div>{uploadText}</div>
        </div>
      );
    }
  };
  const uploadClassName = useMemo(() => {
    return classNames(className, {
      'yb-upload-small': size === 'small',
    });
  }, [size, className]);

  return (
    <ProUpload
      showUploadList={{
        showRemoveIcon: !disabled,
      }}
      multiple={true}
      disabled={disabled}
      listType={listType}
      {...restProps}
      className={uploadClassName}
      onChange={handleChange}
      beforeUpload={handleBeforeUpload}
      data={handleExtraData}
      action={OSSData?.host}
    >
      {disabled ? null : uploadButton()}
    </ProUpload>
  );
};

Plupload.defaultProps = {
  listType: 'picture',
  uploadText: '点击上传',
  uploadIcon: <UploadOutlined />,
  name: 'file',
  size: 'middle',
};

export default Plupload;
